// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/LouguiyaFR.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/LouguiyaFR Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Louguiya';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Louguiya';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

body {
  margin: 0;
  font-family: 'Louguiya', Arial, sans-serif;
  background: #181a20;
  color: #f4f6fa;
  height: 100vh;
  width: 100vw;
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
}

#root {
  height: 100vh;
  width: 100vw;
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
}

.logo {
  position: absolute;
  top: 24px;
  left: 24px;
  width: 60px;
  height: auto;
  z-index: 1000;
}

.footer-credit {
  color: #bdbdbd;
  font-size: 0.75rem;
  letter-spacing: 0.03em;
  font-family: 'Louguiya', Arial, sans-serif;
  text-align: right;
  margin: 12px 24px 0 0;
}

.MuiContainer-root {
  background: #232634 !important;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.MuiTypography-h4 {
  font-family: 'Louguiya', Arial, sans-serif !important;
  font-weight: 900 !important;
  color: #fff !important;
  letter-spacing: 0.08em !important;
  text-shadow: 0 2px 8px rgba(0,0,0,0.10), 0 1px 0 #fff1 !important;
  font-size: 3rem !important;
  text-transform: uppercase;
}

.MuiTypography-body2 {
  color: #f4f6fa !important;
  font-size: 1.18rem !important;
  margin-top: 16px !important;
  margin-bottom: 8px !important;
}

.leaflet-container {
  background: #20232a !important;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

/* Move Leaflet zoom control below header */
.leaflet-top.leaflet-left {
  margin-top: 85px !important;
}

.leaflet-container {
  height: 100% !important;
  width: 100% !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,+DAAqD;EACrD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,+DAA0D;EAC1D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,iEAAiE;EACjE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":["@font-face {\n  font-family: 'Louguiya';\n  src: url('./fonts/LouguiyaFR.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Louguiya';\n  src: url('./fonts/LouguiyaFR Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Louguiya', Arial, sans-serif;\n  background: #181a20;\n  color: #f4f6fa;\n  height: 100vh;\n  width: 100vw;\n  min-height: 100vh;\n  min-width: 100vw;\n  overflow: hidden;\n}\n\n#root {\n  height: 100vh;\n  width: 100vw;\n  min-height: 100vh;\n  min-width: 100vw;\n  overflow: hidden;\n}\n\n.logo {\n  position: absolute;\n  top: 24px;\n  left: 24px;\n  width: 60px;\n  height: auto;\n  z-index: 1000;\n}\n\n.footer-credit {\n  color: #bdbdbd;\n  font-size: 0.75rem;\n  letter-spacing: 0.03em;\n  font-family: 'Louguiya', Arial, sans-serif;\n  text-align: right;\n  margin: 12px 24px 0 0;\n}\n\n.MuiContainer-root {\n  background: #232634 !important;\n  border-radius: 18px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.12);\n  padding-top: 32px !important;\n  padding-bottom: 32px !important;\n}\n\n.MuiTypography-h4 {\n  font-family: 'Louguiya', Arial, sans-serif !important;\n  font-weight: 900 !important;\n  color: #fff !important;\n  letter-spacing: 0.08em !important;\n  text-shadow: 0 2px 8px rgba(0,0,0,0.10), 0 1px 0 #fff1 !important;\n  font-size: 3rem !important;\n  text-transform: uppercase;\n}\n\n.MuiTypography-body2 {\n  color: #f4f6fa !important;\n  font-size: 1.18rem !important;\n  margin-top: 16px !important;\n  margin-bottom: 8px !important;\n}\n\n.leaflet-container {\n  background: #20232a !important;\n  border-radius: 14px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n}\n\n/* Move Leaflet zoom control below header */\n.leaflet-top.leaflet-left {\n  margin-top: 85px !important;\n}\n\n.leaflet-container {\n  height: 100% !important;\n  width: 100% !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
